var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"right-card pt-10 pb-10 pl-2 pr-2"},[_c('h3',{staticStyle:{"color":"#069 !important"}},[_vm._v("Start now")]),_c('p',{staticClass:"card-p text-center mb-0",staticStyle:{"margin-top":"16px"}},[_vm._v(" Select services here ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }